import msalInstance from '../msalConfig';

/**
 * Gets an Outlook/Microsoft Graph access token via MSAL (popup if needed).
 * Use this when the workflow Send Email step requires the user to sign in via the same flow as the Send Email page.
 * @returns {Promise<string>} accessToken for Mail.Send
 * @throws When user cancels popup or token acquisition fails
 */
export async function getOutlookAccessTokenForWorkflow() {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    await msalInstance.loginPopup({ scopes: ['User.Read', 'Mail.Send'] });
  }
  const request = {
    scopes: ['Mail.Send'],
    account: msalInstance.getAllAccounts()[0]
  };
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error.name === 'InteractionRequiredAuthError') {
      const interactiveResponse = await msalInstance.acquireTokenPopup(request);
      return interactiveResponse.accessToken;
    }
    throw error;
  }
}
